import ScrollAnimation from "react-animate-on-scroll";
import { Badge, Col, Container, Image, Row } from "react-bootstrap";
import "../emasterStory/style.scss";
import { AnimatedLine } from "../../common/designParts/animatedUnderline";

export const CampaignStory = () => {
  return (
    <div className="emaster-section pt-5 pb-5">
      <div id="campaigncasestudy"></div>
      <Container>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <ScrollAnimation
              animateIn="animate-text"
              duration={5}
              animateOnce={true}
            >
              <h2 className="h2heading1">
                Our
                <span className="bold">
                  <span className="bold"> Success Stories</span>
                </span>
              </h2>
            </ScrollAnimation>

            <AnimatedLine
              className="animateline"
              width={"150px"}
              margin={"-5px 0 10px 0"}
            >
              <ScrollAnimation
                animateIn="fadeInLeft"
                duration={2}
                animateOnce={true}
                className="no-animation"
              >
                <div className="line"></div>
              </ScrollAnimation>
            </AnimatedLine>
          </Col>
        </Row>

        <div className="detail-section">
          <Row>
            <Col xs={8} sm={8} md={8} lg={8} xl={8}>
              <div className="detail">
                <Image
                  src="https://6725abb7-7926-49cd-89ec-e9663b1da57c.s3.us-west-2.amazonaws.com/home-v2/adobe.png"
                  fluid
                  style={{
                    maxWidth: "60%",
                    display: "block",
                    margin: "10px 0",
                  }}
                />
                <h3>Campaign Management for internal team newsletters.</h3>

                <div className="badge-section d-none d-lg-block">
                  <Badge variant="danger">UI/UX SERVICES</Badge>
                  <Badge variant="danger">CAMPAIGN MANAGEMENT</Badge>
                  <Badge variant="danger">NEWSLETTER</Badge>
                  <Badge variant="danger"> ADOBE CREATIVE SUITE</Badge>
                  <Badge variant="danger"> RESPONSIVE DESIGN</Badge>
                  <Badge variant="danger">DIGITAL MARKETING</Badge>
                </div>
                <p className="d-none d-lg-block">
                  The promotion of Adobe’s products required monthly newsletter
                  creation to keep its customers and contacts informed about the
                  updates. Leveraging the creative guidelines, A
                  mobile-optimized template was created for efficient branding.
                </p>
              </div>
            </Col>
            <Col xs={4} sm={4} md={4} lg={4} xl={4} className="p-0">
              <div className="image-detail">
                <Image src="https://6725abb7-7926-49cd-89ec-e9663b1da57c.s3.us-west-2.amazonaws.com/adobe/product-email-newsletter-series.png" fluid style={{width:"85%"}} />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};
